import React from "react";
import classnames from "classnames";
import { Icon, IconGlyph } from "../../lib/Icon";
import { useBreakpoint } from "../../hooks";

interface IDownloadButtonProps {
  href: string;
  label?: string;
  variant?: "basic";
  className?: string;
}

export const DownloadButton = ({
  href,
  label,
  variant,
  className,
}: IDownloadButtonProps) => {
  const classNames = classnames("viewport-toggle-button", "download-button", "download-button web-gallery-download-button-pendo-tracking");
  const { isDesktop } = useBreakpoint();

  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = href;
    a.download = "true";
    a.click();
  };

  return (
    <button onClick={handleDownload} className={classNames}>
      {isDesktop ? label : (<Icon glyph={IconGlyph.DOWNLOAD}></Icon>)}
    </button>
  );
};
